import React, { useEffect, useState } from "react";
import { Loader, Confirm, Input, Button, Icon } from "semantic-ui-react";
import { Student } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { CustomTable, BasicModal } from "../../../Shared";
import { NewStudentForm } from "../NewStudentForm";
import { ListRegisteredPayments } from "../ListRegisteredPayments";
import { ListRegisteredDocument } from "../ListRegisteredDocument";
import { StatusForm } from "../StatusForm";
import "./ListStudent.scss";

const studentController = new Student();

export function ListStudent(props) {
  const { gradeId, academicCycle, reload, onReload } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { accessToken } = useAuth();

  const [students, setStudents] = useState(null);
  const [studentActive, setStudentActive] = useState(null);
  const [filters, setFilters] = useState({ name: "", dni: "", phone: "" });
  const [searchInputs, setSearchInputs] = useState({ name: "", dni: "", phone: "" });

  const [showConfirm, setShowConfirm] = useState(false);
  const [showModalStudent, setShowModalStudent] = useState(false);
  const [showModalPayments, setShowModalPayments] = useState(false);
  const [showModalDocuments, setShowModalDocuments] = useState(false);
  const [showModalStatus, setShowModalStatus] = useState(false);

  const onOpenCloseConfirm = (row) => {
    setStudentActive(row);
    setShowConfirm((prevState) => !prevState);
  };

  const onOpenCloseModalStudent = (row) => {
    setStudentActive(row);
    setShowModalStudent((prevState) => !prevState);
  };

  const onOpenCloseModalPayments = (row) => {
    setStudentActive(row);
    setShowModalPayments((prevState) => !prevState);
  };

  const onOpenCloseModalDocuments = (row) => {
    setStudentActive(row);
    setShowModalDocuments((prevState) => !prevState);
  };

  const onOpenCloseModalStatus = (row) => {
    setStudentActive(row);
    setShowModalStatus((prevState) => !prevState);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 1:
        return "blue";
      case 2:
        return "green";
      case 3:
        return "red";
      case 4:
        return "black";
      case 5:
        return "grey";
      default:
        return "brown";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "ACTIVO";
      case 2:
        return "APROBADO";
      case 3:
        return "DESAPROBADO";
      case 4:
        return "RETIRADO";
      case 5:
        return "INACTIVO";
      default:
        return "SIN DEFINIR";
    }
  };

  const onDelete = async () => {
    try {
      const result = await studentController.deleteStudent(
        accessToken,
        studentActive.id,
        academicCycle.id
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const tableConfig = {
    headers: [
      "Apellidos y Nombres",
      "DNI",
      "Correo electrónico",
      "Teléfono",
      "Categoría de pago",
      "Estado",
      "Acciones",
    ],
    fields: [
      {
        field: "User.lastname+ +User.secondLastname+ +User.firstname",
        dataType: "text",
      },
      {
        field: "User.dni",
        dataType: "text",
        align: "center",
      },
      {
        field: "User.email",
        dataType: "text",
      },
      {
        field: "User.phone",
        dataType: "text",
        align: "center",
      },
      {
        field: "PaymentCategory.name",
        dataType: "text",
        align: "center",
      },
      {
        field: "status",
        component: "Label",
        getColor: getStatusColor,
        getText: getStatusText,
        align: "center",
      },
      {
        buttons: [
          {
            color: "blue",
            icon: "pencil alternate",
            placeholder: "Actualizar estudiante",
            onClick: onOpenCloseModalStudent,
          },
          {
            color: "green",
            icon: "dollar",
            placeholder: "Gestión de pagos",
            onClick: onOpenCloseModalPayments,
          },
          {
            color: "teal",
            icon: "file alternate",
            placeholder: "Gestión de documentos",
            onClick: onOpenCloseModalDocuments,
          },
          {
            color: "orange",
            icon: "cog",
            placeholder: "Cambiar de estado",
            onClick: onOpenCloseModalStatus,
          },
          {
            color: "red",
            icon: "trash",
            placeholder: "Eliminar estudiante",
            onClick: onOpenCloseConfirm,
          },
        ],
      },
    ],
    columnWidths: ["30%", "10%", "30%", "10%", "15%", "10%"],
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [gradeId]);

  useEffect(() => {
    (async () => {
      try {
        const response = await studentController.getStudents(
          accessToken,
          gradeId,
          academicCycle.id,
          filters,
          currentPage,
          itemsPerPage
        );
        setStudents(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [gradeId, currentPage, reload, filters, itemsPerPage]);

  // Filter handlers
  const handleSearchInputChange = (field, value) => {
    setSearchInputs((prev) => ({ ...prev, [field]: value }));
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setFilters({ ...searchInputs });
    onReload();
  };

  const handleClearFilters = () => {
    setSearchInputs({ name: "", dni: "", phone: "" });
    setFilters({ name: "", dni: "", phone: "" });
    setCurrentPage(1);
    onReload();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const getFullName = (user) => {
    if (!user) return "";
    const { firstname, lastname, secondLastname } = user;
    return `${lastname ? ` ${lastname}` : ""} ${
      secondLastname ? ` ${secondLastname}` : ""
    } ${firstname ? ` ${firstname}` : ""}`;
  };

  const fullName = getFullName(studentActive?.User);

  if (!students) return <Loader active inline="centered" />;

  return (
    <>
      {/* Filters */}
      <div className="student__list-filters">
        <Input
          icon="search"
          iconPosition="left"
          placeholder="Buscar por nombre..."
          value={searchInputs.name}
          onChange={(e) => handleSearchInputChange("name", e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Input
          icon="id card"
          iconPosition="left"
          placeholder="Buscar por DNI..."
          value={searchInputs.dni}
          onChange={(e) => handleSearchInputChange("dni", e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Input
          icon="phone"
          iconPosition="left"
          placeholder="Buscar por teléfono..."
          value={searchInputs.phone}
          onChange={(e) => handleSearchInputChange("phone", e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Button primary onClick={handleSearch}>
          <Icon name="search" /> Buscar
        </Button>
        <Button color="grey" onClick={handleClearFilters}>
          <Icon name="eraser" /> Limpiar filtros
        </Button>
      </div>
      
      <div className="student__list">
        <CustomTable
          color="blue"
          tableConfig={tableConfig}
          data={students.data}
          pagination={students.pagination}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onItemsPerPageChange={handleItemsPerPageChange}
          onReload={onReload}
        />
      </div>
      <BasicModal
        size="small"
        title={`Actualizar estudiante: ${fullName}`}
        show={showModalStudent}
        close={onOpenCloseModalStudent}
        scrolling={true}
      >
        <NewStudentForm
          student={studentActive}
          onReload={onReload}
          onClose={onOpenCloseModalStudent}
        />
      </BasicModal>
      <BasicModal
        size="fullscreen"
        title={`Gestión de pagos de ${fullName}`}
        show={showModalPayments}
        close={onOpenCloseModalPayments}
      >
        <ListRegisteredPayments studentActive={studentActive} />
      </BasicModal>
      <BasicModal
        size="large"
        title={`Gestión de documentos de ${fullName}`}
        show={showModalDocuments}
        close={onOpenCloseModalDocuments}
      >
        <ListRegisteredDocument studentActive={studentActive} />
      </BasicModal>
      <BasicModal
        title={`Cambiar estado de ${fullName}`}
        show={showModalStatus}
        close={onOpenCloseModalStatus}
      >
        <StatusForm
          onReload={onReload}
          onClose={onOpenCloseModalStatus}
          student={studentActive}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`¿Eliminar el estudiante ${fullName}?`}
        size="mini"
      />
    </>
  );
}
